module.exports = __webpack_public_path__ + "img/ug335.86030b4f.png";